import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var session = function session() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isLoading: true,
    fetched: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'GET_TOKEN':
      state = _objectSpread({}, state, {
        token: action.data
      });
      return state;

    case 'GET_USER_ID':
      state = _objectSpread({}, state, {
        userId: action.data,
        trial: action.trial,
        roles: action.roles,
        group: action.group,
        excludedCategories: action.group.field_categories_to_exclude
      });
      return state;

    case 'USER_IS_LOGGED_IN':
      var user = action.data;
      var userPicture;
      action.included && action.included.map(function (included) {
        if (included.type === "file--image") {
          userPicture = included;
        }

        if (included.type === "taxonomy_term--job_titles") {
          user.jobTitle = included;
        }

        return true;
      });
      state = _objectSpread({}, state, {
        user: user,
        userPicture: userPicture
      });
      return state;

    case 'USER_IS_ANONYMOUS':
      state = _objectSpread({}, state, {
        user: action.data
      });
      return state;

    case 'GET_NET_PROMOTER_SCORE':
      state = _objectSpread({}, state, {
        netPromoterScore: action.data
      });
      state.fetched.netPromoterScore = true;
      return state;

    case 'GET_USER_BADGES':
      state = _objectSpread({}, state, {
        userBadges: action.data
      });
      state.fetched.userBadges = true;
      return state;

    case 'GET_ACTIVE_USER_LEARNING_PATH':
      state = _objectSpread({}, state, {
        activeUserLearningPath: action.data
      });
      return state;

    case 'GET_USER_LEARNING_PATHS':
      state = _objectSpread({}, state, {
        userLearningPaths: action.data
      });
      state.fetched.userLearningPaths = true;
      return state;

    case 'GET_BADGE':
      var badges;

      if (state.badges) {
        state.badges.push(action.data);
        badges = state.badges;
      } else {
        badges = [];
        badges.push(action.data);
      }

      state = _objectSpread({}, state, {
        badges: badges
      });
      return state;

    case 'UPDATE_USER':
      state = _objectSpread({}, state, {
        user: action.data
      });
      return state;

    case 'UPDATE_USER_PICTURE':
      state = _objectSpread({}, state, {
        userPicture: action.data
      });
      return state;

    default:
      return state;
  }
};

export default session;